import { useAppSelector } from '@/shared/hooks';

import { reportsModel } from '@/entities/reports';

export const useResolvedToothID = (toothID?: string): string => {
  const activeToothID = useAppSelector(
    reportsModel.selectors.selectActiveToothID,
  );

  return toothID ?? activeToothID;
};
